<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import AppLightModeSwitch from "./AppLightModeSwitch.vue";

import { useUserStore } from "@/stores/user";

const userStore = useUserStore();
const router = useRouter();

const settingsMenu = ref(null);

function toggleSettingsMenu(event) {
  settingsMenu.value.toggle(event);
}

const overlayMenuItems = ref([
  {
    separator: true,
  },
  {
    label: "Your profile",
    command: () => {
      router.push("/profile");
    },
  },
  {
    label: "Terms of Use",
    command: () => {
      router.push("/terms-of-use");
    },
  },
  {
    label: "Privacy Policy",
    command: () => {
      router.push("/privacy-policy");
    },
  },
  {
    label: "Log out",
    command: () => {
      userStore.logout();
      router.push("/login");
    },
  },
]);
</script>
<template>
  <Menu
    ref="settingsMenu"
    :model="overlayMenuItems"
    :popup="true"
    class="w-auto max-w-lg"
  >
    <template #start>
      <span class="inline-flex flex-col p-2">
        <div class="flex flex-col">
          <span class="font-semibold">{{ userStore.user.full_name }}</span>
          <span class="text-sm">{{ userStore.user.email }}</span>
        </div>
        <div class="pt-2">
          <AppLightModeSwitch class="w-8 h-auto" />
        </div>
      </span>
    </template>
    <template #item="{ item, props }">
      <a
        v-ripple
        class="flex justify-start !p-1.5 text-left"
        v-bind="props.action"
      >
        <span>{{ item.label }}</span>
      </a>
    </template>

    <template #end> </template>
  </Menu>
  <Button
    type="button"
    class="topbar-sidebarbutton"
    @click="toggleSettingsMenu"
  >
    <img :src="userStore.user.avatar_url" alt="Profile" />
  </Button>
</template>
